import * as BBApi from '.'

const rootUrl = BBApi.host + '/municipalities'

type Query = { active?: boolean; country?: string }

export const query = async (query: Query = {}) => {
	const url = new URL(rootUrl)
	if ('active' in query) url.searchParams.append('active', String(query.active))
	if ('country' in query) url.searchParams.append('country', String(query.country))

	const response = await BBApi.get(url.href)
	const municipalities = await response.json()

	return municipalities
}

export async function get(id: number): Promise<any> {
	const response: Response = await BBApi.get(rootUrl + `/${id}`)
	const json: any = await response.json()
	return json
}

export async function create(municipality: any): Promise<any> {
	throw new Error('Not implemented')
}

export async function update(id: number, municipality: any): Promise<void> {
	throw new Error('Not implemented')
}

export async function remove(id: number): Promise<void> {
	throw new Error('Not implemented')
}
